import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brouillon-devis',
  templateUrl: './brouillon-devis.component.html',
  styleUrls: ['./brouillon-devis.component.scss']
})
export class BrouillonDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
